import { render, staticRenderFns } from "./BasCustomerList.vue?vue&type=template&id=6d100426&scoped=true&"
import script from "./BasCustomerList.vue?vue&type=script&lang=js&"
export * from "./BasCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./BasCustomerList.vue?vue&type=style&index=0&id=6d100426&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d100426",
  null
  
)

export default component.exports